import { defaultDateTimeFormatter, nomeUgAbreviacaoFormatter, TableField } from "@/types/table-field";

const id: TableField = {
  key: "id_pc",
  label: "ID",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: "align-center",
};
const sistema: TableField = {
  key: "id_sistema",
  label: "Sistema",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["align-center", "naoQuebrar"],
  formatter: (val) => val == 1 ? 'Execução' : val == 2 ? 'Folha' : val == 3 ? 'Empresa' : val == 4 ? 'Educação' : val,
};
const nome: TableField = {
  key: "nome_ug",
  label: "Nome",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: "align-center",
  formatter: nomeUgAbreviacaoFormatter,
};
const situacao: TableField = {
  key: "situacao",
  label: "Situação",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["align-center", "naoQuebrar"],
};
const mes: TableField = {
  key: "mes",
  label: "Mês",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["align-center", "naoQuebrar"],
};
const data: TableField = {
  key: "dt_entrega",
  label: "Data",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  formatter: defaultDateTimeFormatter,
};

export const fieldsDashboard: TableField[] = [id, sistema, nome, situacao, mes,data];
